import { types, flow } from 'mobx-state-tree'
import { createEvidence } from '~/services/parking/ticket'
import { getUserSessionToken } from '~/stores/parkingTicket/flow/parkingConfig'
import PersistedImage from '~/stores/models/persistedImage'

const PersistedParkingEvidence = types
  .model('PersistedParkingEvidence', {
    wiType: types.maybeNull(types.string)
  })
  .actions(self => ({
    setType(type) {
      self.wiType = type
    },
    setEvidenceImage: flow(function* evidenceImage(objectId) {
      const evidenceData = {
        evidenceType: self.wiType,
        evidenceImage: self.base64EncodedImage
      }
      const sessionToken = getUserSessionToken(self)
      yield createEvidence(objectId, evidenceData, sessionToken)
    })
  }))

const PersistedParking = types.compose(
  PersistedParkingEvidence,
  PersistedImage
)

export default PersistedParking